/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api"
import { ENTITYNAME, GENDERS, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";


export const TargetGroupsEditForm = (props) => {
    const lang = useTranslation();
    const blankDataItem = {
        ...props.item,
        SID: props.item.SID ?? 0,
        Name: props.item.copy ? 'copy of ' + props.item.Name : props.item.Name ?? '',
        Gender: (props.item?.Gender) ? { _id: props.item.Gender, Description: utility.getKeyByValue(GENDERS, props.item.Gender) } : {},
        MinAge: props.item.MinAge ?? '',
        MaxAge: props.item.MaxAge ?? '',
        Archive: props.item.Archive ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [genders, setGenders] = useState([]);

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        const genderRes = Object.keys(GENDERS).map(x => ({
            _id: GENDERS[x],
            Description: x
        }));
        setGenders(genderRes);
    };


    //function to check the validation in form
    const isValid = () => {
        if (!dataItem.Name || dataItem.Name == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_name_error_message}` });
            return false;
        }
        if (!dataItem.Gender || Object.keys(dataItem.Gender).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_gender_error_message}` });
            return false;
        }
        if (!dataItem.MinAge || dataItem.MinAge == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_minimum_age_error_message}` });
            return false;
        }
        if(parseInt(dataItem.MinAge) < 0){
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.minimum_age_should_be_greater_than_zero_error_message}` });
            return false;
        }
        if (!dataItem.MaxAge || dataItem.MaxAge == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_maximum_age_error_message}` });
            return false;
        }
        if(parseInt(dataItem.MaxAge) < 0){
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.maximum_age_should_be_greater_than_zero_error_message}` });
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {

        if (!isValid()) return;
        const saveData = {
            _id: dataItem._id,
            SID: dataItem.SID ?? 0,
            Name: dataItem?.Name,
            Gender: Object.keys(dataItem.Gender).length > 0 ? dataItem.Gender._id : '',
            MinAge: parseInt(dataItem.MinAge),
            MaxAge: parseInt(dataItem.MaxAge),
            Archive: dataItem.Archive ?? false,
        }
        console.log(saveData);

        let res = await API.saveData(ENTITYNAME.TargetGroups, saveData);
        if (res.success) {
            utility.deleteLocalStorageItem(ENTITYNAME.TargetGroups);
            props.cancelEdit();
            props.refresh();
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }

    }

    return (
        <BossDialog
            title={props.item.SID > 0 ? props.item.Name : lang.create_target_group_header}
            onClose={props.cancelEdit}
            width={"600px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.name_label} *</label>
                    <input
                        name={"Name"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Name}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.gender_label} *</label>
                    <DropDownList
                        data={genders}
                        name="Gender"
                        dataItemKey="_id"
                        textField="Description"
                        onChange={onChange}
                        value={dataItem.Gender}
                        style={{ backgroundColor: 'white', height: '32px' }}
                    />
                </div>
            </div>
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.minimum_age_label} *</label>
                    <input
                        name={"MinAge"}
                        type="number"
                        min={0}
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.MinAge}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.maximum_age_label} *</label>
                    <input
                        name={"MaxAge"}
                        type="number"
                        min={0}
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.MaxAge}
                    />
                </div>
            </div>
            <div className="row form-group">
                <div className="col" >
                    <input type={"checkbox"} name={"Archive"}
                        onChange={(e) => onChange(e)}
                        value={dataItem.Archive}
                        checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                </div>

            </div>
        </BossDialog>)
};